import React, { useState, useCallback } from "react";
import classNames from "classnames";
import useClickOut from "../../hooks/use-click-out";
import { withPrefix } from "gatsby";

const LanguageDropdown = ({ className }) => {
  const [language, setLanguage] = useState(false);
  const toggleLanguage = useCallback(() => setLanguage((value) => !value), []);
  const languageRef = useClickOut(language, setLanguage);
  const pathPrefix = withPrefix("/");
  const languages = ["/de_CH/", "/fr_CH/", "/it_CH/"].includes(pathPrefix)
    ? ["de_CH", "fr_CH", "it_CH"]
    : ["/fr_BE/", "/nl_BE/"].includes(pathPrefix)
    ? ["fr_BE", "nl_BE"]
    : [];

  return (
    <>
      {languages?.length ? (
        <div className={classNames("utility-language-dropdown-wrapper", className)}>
          <div className={`utility-language-dropdown language-dropdown${language ? " open" : ""}`}>
            <button onClick={toggleLanguage} className="utility-language-dropdown__btn">
              {languages?.[languages.indexOf(pathPrefix.replaceAll("/", ""))]
                ?.split("_")[0]
                ?.replace("/", "")
                ?.toUpperCase()}
            </button>
            <div ref={languageRef} className="language-dropdown__content">
              {languages
                ?.filter((item) => item !== pathPrefix.replaceAll("/", ""))
                ?.map((item, index) => (
                  <div key={index}>
                    <a href={`/${item}/`} className="language-dropdown__link">
                      {item?.split("_")[0]?.replace("/", "")?.toUpperCase()}
                    </a>
                  </div>
                ))}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default LanguageDropdown;
